import "./App.css";
import Navbar from "./Components/navbar/navbar";
import Header from "./Components/header/header";
const App = () => {
  return (
    <>
      <Navbar />
      <Header />
    </>
  );
};
export default App;
